import React, { useState } from "react";
import {
  createAccount,
  getAllAccountForEdit,
  updateSingleAccount,
  deleteSingleAccount,
} from "../../api/endpoints/chartOfAccount";
import { authSelector } from "../../store/selectors/index";
import { useSelector } from "react-redux";
import { Modal, message, Select } from "antd";
import { AiFillSave } from "react-icons/ai";
import { AiFillDelete } from "react-icons/ai";
import { LuView } from "react-icons/lu";
import { AiFillEdit } from "react-icons/ai";
import { AiFillFileAdd } from "react-icons/ai";
import { BiExit } from "react-icons/bi";
import "./chartOfAccount.css";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import SideBar from "../sidebar/sideBar";
const { Option } = Select;

const ChartOfAccount = () => {
  const { user, access_token } = useSelector(authSelector);
  const [fieldsShow, setFieldsShow] = useState(false);
  const [type, setType] = useState("ADD");
  const [itemsQueue, setItemsQueue] = useState([]);
  const [state, setState] = useState({
    generalLedgerCodes: [],
    generalLedgerCode: "",
    description: "",
    closed: "",
  });

  const clearState = () => {
    setState({
      id: "",
      generalLedgerCode: "",
      generalLedgerCodes: state.generalLedgerCodes,
      description: "",
      closed: "",
    });
    setItemsQueue([]);
  };

  //   console.log(state, "Vall");
  const editHandler = async (e) => {
    const results = await getAllAccountForEdit(access_token);
    if (results.data.length === 0) {
      message.error("No Record Found in this date");
    }
    if (results.success) {
      const payload = results.data.reduce((acc, curr) => {
        return [
          ...acc,
          {
            generalLedgerCode: curr.Code,
            description: curr.Description,
          },
        ];
      }, []);
      setItemsQueue(payload);
      generatePDF(payload);
    } else {
      message.error(results.message);
    }
  };
  const generatePDF = (data, siteName, siteAddress) => {
  if (!Array.isArray(data) || data.length === 0) {
    message.error("No data to generate report!");
    return;
  }

  const doc = new jsPDF("p", "mm", "a4");

  // 🔹 Header
  doc.setFontSize(9);
  doc.text(`Report Date : ${new Date().toLocaleDateString()}`, 105, 10, {
    align: "center",
  });

  doc.setFontSize(10);
  doc.setFont(undefined, "normal");
  doc.text("Chart of Accounts", 105, 16, { align: "center" });

  // 🔹 Table
  autoTable(doc, {
    startY: 22,

    head: [["A/c Code", "Description"]],
    body: data.map((item) => [
      item.generalLedgerCode,
      item.description,
    ]),

    theme: "plain", // (no grid like your image)

    margin: { left: 20, right: 20 },

    styles: {
      fontSize: 9,
      cellPadding: { top: 1, bottom: 1 },
      textColor: [0, 0, 0],
    },

  headStyles: {
  fontStyle: "bold",
  halign: "left",
  cellPadding: {
    top: 1,
    bottom: 1,   // 🔥 this creates space before the underline
    left: 1,
    right: 1,
  },
  lineWidth: 0.6,
  lineColor: [0, 0, 0],
},


    columnStyles: {
      0: { cellWidth: 40, halign: "left" },
      1: { cellWidth: 120, halign: "left" },
    },

    // 🔥 Bold parent accounts (ending with 000)
    didParseCell: function (data) {
      if (data.section === "body") {
        const code = data.row.raw[0];

        if (typeof code === "string" && code.endsWith("000")) {
          data.cell.styles.fontStyle = "bold";
          data.cell.styles.fontSize = 10;
        }
      }
    },

    // // 🔹 Draw header underline only
    // didDrawPage: function () {
    //   const y = 33;
    //   doc.setLineWidth(0.5);
    //   doc.line(20, y, 190, y);
    // },
  });

  const pdfBlob = doc.output("blob");
  const pdfUrl = URL.createObjectURL(pdfBlob);
  window.open(pdfUrl);
};

  // const generatePDF = (data) => {
  //   if (!Array.isArray(data) || data.length === 0) {
  //     message.error("No data to generate report!");
  //     return;
  //   }

  //   const doc = new jsPDF("p", "mm", "a4");

  //   doc.setFontSize(8);
  //   doc.text("Chart Of Account", 105, 18, { align: "center" });

  //   // Table
  //   autoTable(doc, {
  //     head: [["Code", "Description"]],
  //     body: data.map((item) => [item.generalLedgerCode, item.description]),
  //     startY: 15,
  //     theme: "grid",
  //     margin: { left: 15, right: 15 },

  //     styles: {
  //       fontSize: 10,
  //       cellPadding: 1,
  //       textColor: [0, 0, 0],
  //       lineColor: [0, 0, 0],
  //       lineWidth: 0.4,
  //     },

  //     headStyles: {
  //       fillColor: [255, 255, 255],
  //       textColor: [0, 0, 0],
  //       fontStyle: "bold",
  //       halign: "center",
  //       lineColor: [0, 0, 0],
  //       lineWidth: 0.5,
  //     },

  //     columnStyles: {
  //       0: { halign: "center", cellWidth: 40 },
  //       1: { halign: "left", cellWidth: 120 },
  //     },

  //     // 🔥 THIS IS THE KEY PART
  //     didParseCell: function (hookData) {
  //       if (hookData.section === "body") {
  //         const code = hookData.row.raw[0]; // Code column value

  //         // ✅ If code ends with '000'
  //         if (typeof code === "string" && code.endsWith("000")) {
  //           hookData.cell.styles.fontStyle = "bold";
  //         }
  //       }
  //     },
  //   });

  //   const pdfBlob = doc.output("blob");
  //   const pdfUrl = URL.createObjectURL(pdfBlob);
  //   window.open(pdfUrl);
  // };

  const onChangeText = (e, object) => {
    if (object) {
      const { name, value } = object;
      setState({
        ...state,
        [name]: value,
      });
    } else {
      const { name, value } = e.target;
      setState({
        ...state,
        [name]: value,
      });
    }
  };
  const addTank = async () => {
    setType("SAVE");
    setFieldsShow(true);
  };
  //   console.log(state.generalLedgerCode.length,"leng")
  const saveTank = async (e) => {
    if (state.generalLedgerCode.length < 9) {
      return message.error(
        "Account Number must contain exactly 9 numeric digits."
      );
    }
    if (!state.generalLedgerCode || !state.description) {
      return message.error(
        `Please type ${
          !state.generalLedgerCode
            ? "Account Number"
            : !state.description
              ? "Description"
              : ""
        }`
      );
    }
    const payload = {
      code: state.generalLedgerCode,
      CCode: state.generalLedgerCode,
      Description: state.description,
      Closed: Number(state.closed),
      grpId: Number(user.grpId),
      siteId: Number(user.siteId),
    };

    const results = await createAccount(payload, access_token);
    if (results.success) {
      message.success(results.message || "Successfully entered!");
      clearState();
      setFieldsShow(false);
      setType("ADD");
    } else {
      message.error(results.message);
    }
  };

  const editTank = async () => {
    setType("EDIT");
    setFieldsShow(true);
    const _ledgerAccounts = await getAllAccountForEdit(access_token);
    if (_ledgerAccounts.success) {
      setState({
        ...state,
        generalLedgerCodes: _ledgerAccounts.data,
      });
    }
    console.log(state.generalLedgerCodes, "codes");
  };

  const saveEditTank = async (e) => {
    if (type === "EDIT") {
      if (state.generalLedgerCode.length < 9) {
        return message.error(
          "Account Number must contain exactly 9 numeric digits."
        );
      }
      if (!state.generalLedgerCode || !state.description) {
        return message.error(
          `Please type ${
            !state.generalLedgerCode
              ? "Account Number"
              : !state.description
                ? "Description"
                : ""
          }`
        );
      }
      const data = {
        // id: state.id,
        Code: state.generalLedgerCode,
        Description: state.description,
        Closed: Number(state.closed),
      };
      const results = await updateSingleAccount(data, access_token);
      if (results.success) {
        message.success(results.message || "Successfully Updated!");
        clearState();
        setFieldsShow(false);
        setType("ADD");
      } else {
        message.error(results.message);
      }
    } else {
      if (!state.generalLedgerCode)
        return message.error("Please Select Account");
      modal.confirm({
        title: `Confirm`,
        content: "Are you sure you want to delete this Account?",
        okText: "Delete",
        cancelText: "Cancel",
        onOk: confirmDeleteNozel,
      });
    }
  };
  const confirmDeleteNozel = async () => {
    const data = {
      Code: state.generalLedgerCode,
    };
    const results = await deleteSingleAccount(data, access_token);
    if (results.success) {
      message.success(results.message || "Deleted Successfully!");
      clearState();
      setFieldsShow(false);
      setType("ADD");
    } else {
      message.error(results.message);
    }
  };

  const [modal, contextHolder] = Modal.useModal();
  const deleteNozel = async () => {
    setType("DELETE");
    setFieldsShow(true);
    const _ledgerAccounts = await getAllAccountForEdit(access_token);
    if (_ledgerAccounts.success) {
      setState({
        ...state,
        generalLedgerCodes: _ledgerAccounts.data,
      });
    }
  };
  const confirmDelete = () => {
    modal.confirm({
      title: `Confirm`,
      content: "You want to delete Account?",
      okText: "Yes",
      cancelText: "Cancel",
      onOk: deleteNozel,
    });
  };

  const clearStates = () => {
    clearState();
    setFieldsShow(false);
    setType("ADD");
  };
  console.log(state, "state");
  return (
    <>
      <div className="flex  bg-black main">
        <SideBar />
        <div className="h-full  flex flex-col content-center  w-full">
          {/* <Header /> */}
          <div className="flex justify-center">
            <div className="meterTableMain flex flex-col justify-items-center justify-center w-1/2 ml-10 mt-5 mr-10">
              <div className="bg-blue-500 headingBox flex justify-center">
                <h1 className=" text-white">Add Chart of Account</h1>
                {contextHolder}
              </div>
              <div className="flex flex-col p-2 content-center items-center justify-items-center justify-evenly">
                {fieldsShow && (
                  <div className="w-90">
                    <div className="flex justify-between mb-3">
                      <label className="text-white" for="fname">
                        Account Number:
                      </label>
                      {type === "EDIT" || type === "DELETE" ? (
                        <>
                          <Select
                            showSearch
                            placeholder="Account Number"
                            optionFilterProp="children"
                            className="w-40 bg-black text-slate-400 "
                            value={state.generalLedgerCode || "Account Number"}
                            onChange={(e) => {
                              const _accountInfo =
                                state.generalLedgerCodes.find(
                                  (el) => el.Code === e
                                );
                              if (_accountInfo.closed === false) {
                                setState({
                                  ...state,
                                  generalLedgerCode: e,
                                  description: _accountInfo.Description,
                                  closed: 0,
                                });
                              } else {
                                setState({
                                  ...state,
                                  generalLedgerCode: e,
                                  description: _accountInfo.Description,
                                  closed: 1,
                                });
                              }
                            }}
                          >
                            {state.generalLedgerCodes.map((el) => (
                              <Option value={el.Code}>{el.Code}</Option>
                            ))}
                          </Select>
                          <Select
                            showSearch
                            placeholder="Account Description"
                            optionFilterProp="children"
                            className="w-40 bg-black text-slate-400 "
                            value={state.description || "Account Description"}
                            onChange={(e) => {
                              const _accountInfo =
                                state.generalLedgerCodes.find(
                                  (el) => el.Code === e
                                );
                              if (_accountInfo.closed === false) {
                                setState({
                                  ...state,
                                  generalLedgerCode: e,
                                  description: _accountInfo.Description,
                                  closed: 0,
                                });
                              } else {
                                setState({
                                  ...state,
                                  generalLedgerCode: e,
                                  description: _accountInfo.Description,
                                  closed: 1,
                                });
                              }
                            }}
                          >
                            {state.generalLedgerCodes.map((el) => (
                              <Option value={el.Code}>{el.Description}</Option>
                            ))}
                          </Select>
                        </>
                      ) : (
                        <input
                          type="number"
                          name="generalLedgerCode"
                          value={state.generalLedgerCode}
                          onChange={(e) => {
                            const input = e.target.value.slice(0, 9);
                            onChangeText({
                              target: {
                                name: "generalLedgerCode",
                                value: input,
                              },
                            });
                          }}
                          className="bg-black text-slate-400  inpTxt p-2 h-8 ml-3 mb-3"
                        />
                      )}
                    </div>
                    <div className="flex justify-between">
                      <label className="text-white" for="fname">
                        Description :
                      </label>
                      <input
                        type="text"
                        name="description"
                        value={state.description}
                        onChange={onChangeText}
                        className="bg-black text-slate-400  inpTxt p-2 h-8 ml-3 mb-3"
                      />
                    </div>

                    <div className="flex justify-between">
                      <label className="text-white" for="fname">
                        Closed:
                      </label>
                      <Select
                        showSearch
                        className="bg-black text-slate-400  inpTxt w-16 h-8 ml-3 mb-3"
                        placeholder="No"
                        optionFilterProp="children"
                        value={state.closed === "" ? "No" : state.closed}
                        onChange={(value) =>
                          onChangeText({ target: { name: "closed", value } })
                        }
                      >
                        <Option value={0} name="closed">
                          No
                        </Option>
                        <Option value={1} name="closed">
                          Yes
                        </Option>
                      </Select>
                    </div>
                  </div>
                )}

                <div className="flex justify-center">
                  {type === "ADD" && (
                    <button
                      onClick={addTank}
                      className="bg-blue-500 hover:bg-blue-700 flex text-white mt-3 py-1 px-4 rounded"
                    >
                      <AiFillFileAdd className="mr-2 mt-1" />

                      <span>Add</span>
                    </button>
                  )}

                  {type === "SAVE" && (
                    <button
                      onClick={saveTank}
                      className="bg-blue-500 hover:bg-blue-700  flex text-white mt-3 py-1 px-4 rounded"
                    >
                      <AiFillSave className="mt-1 mr-2 " />
                      <span>Save</span>
                    </button>
                  )}
                  {/* <button
                        className="bg-blue-500 hover:bg-blue-700 text-white mt-3 ml-3 py-1 px-4 rounded"
                      >
                      Add
                      </button> */}
                  {type === "ADD" && (
                    <button
                      onClick={editHandler}
                      className="bg-blue-500 hover:bg-blue-700 flex text-white ml-2 mt-3 py-1 px-4 rounded"
                    >
                      <LuView className="mt-1 mr-2 " />
                      <span>View</span>
                    </button>
                  )}
                  {type === "ADD" && (
                    <button
                      onClick={editTank}
                      className="bg-blue-500 hover:bg-blue-700  flex text-white mt-3 ml-3 py-1 px-4 rounded"
                    >
                      <AiFillEdit className="mr-2 mt-1" />

                      <span>Edit</span>
                    </button>
                  )}

                  {(type === "EDIT" || type === "DELETE") && (
                    <button
                      onClick={saveEditTank}
                      className="bg-blue-500 hover:bg-blue-700 text-white ml-2 mt-3 py-1 px-4 rounded"
                    >
                      DONE
                    </button>
                  )}
                  {type === "ADD" && (
                    <button
                      onClick={confirmDelete}
                      className="bg-blue-500 hover:bg-blue-700 flex text-white mt-3 ml-3 py-1 px-4 rounded"
                    >
                      <AiFillDelete className="mr-2 mt-1" />

                      <span>Delete</span>
                    </button>
                  )}
                  {type !== "ADD" && (
                    <button
                      onClick={clearStates}
                      className="bg-blue-500 hover:bg-blue-700 flex text-white mt-3 ml-3 py-1 px-4 rounded"
                    >
                      <BiExit className="mr-2 mt-1" />
                      <span>Exit</span>
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ChartOfAccount;
